<template>
  <div>
    <v-list-item :to="{name: buyoutItemState, params: {sourceId: this.sourceId, buyoutId: item.id}}">
      <v-list-item-avatar v-if="!isSmallWidth">
        <v-img :src="item.preview"></v-img>
      </v-list-item-avatar>
      <v-list-item-content>
        <v-list-item-title>{{item.title}}</v-list-item-title>
        <v-list-item-subtitle>
          <BuyoutStatus
              :min-mode="true"
              :status-id="item.status"
          ></BuyoutStatus>
        </v-list-item-subtitle>
        <v-list-item-subtitle>
          Итого: <b>{{item.amounts.own.sum | number}} {{ccySign}}</b>
          <BuyoutDate
              :dates="item.dates"
              :status="item.status"
          ></BuyoutDate>
        </v-list-item-subtitle>
      </v-list-item-content>

      <v-list-item-action v-if="showMinimalSum">
        <BuyoutMinimalSum
            :actual="item.minimalSumActual"
            :ccy="ccySign"
            :value="item.minimalSum"
        ></BuyoutMinimalSum>
      </v-list-item-action>
      <v-list-item-action
          v-if="showPaymentStatus"
          class="ml-1"
      >
        <v-btn
            icon
            rounded
            color="white"
            :style="{'background-color': payment.color}"
            :ripple="false"
        >
          <v-icon>{{payment.icon}}</v-icon>
        </v-btn>
      </v-list-item-action>
    </v-list-item>
    <v-divider inset></v-divider>
  </div>
</template>

<script>
import BuyoutDate from '@/components/BuyoutDate'
import BuyoutMinimalSum from '@/components/BuyoutMinimalSum'
import BuyoutStatus from '@/components/BuyoutStatus'
import {appStates, ccy, status} from '@/constants'
import {getSourceId} from '@/composables/context'
import Screen from '@/services/screen'
import Statuses from '@/services/statuses'

export default {
  name: 'BuyoutListItem',
  components: {BuyoutMinimalSum, BuyoutDate, BuyoutStatus},
  computed: {
    showMinimalSum: function () {
      return this.item.minimalSumShowLK && this.statusesMinimalSum.includes(this.item.status)
    },
    showPaymentStatus: function () {
      return this.item.status !== Statuses.getStatuses().draft.id && this.item.status !== Statuses.getStatuses().progress.id
          && Statuses.getStatuses().status !== Statuses.getStatuses().stop.id;
    },
    sourceId: getSourceId
  },
  data () {
    return {
      ccySign: ccy[this.item.buyoutCurrency].sign,
      isSmallWidth: Screen.isSmallWidth(),
      payment: status.payment[this.item.paymentStatus],
      buyoutItemState: appStates.sourceItemBuyoutItem.name,
      statusesMinimalSum: Statuses.getStatusesMinimalSum()
    }
  },
  methods: {
    getCcy: function () {
      return this.item.buyoutCurrency
    }
  },
  props: {
    item: {
      required: true,
      type: Object
    }
  }
}
</script>

<style scoped>

</style>